import { defu } from 'defu'
const foldedMatcher = /* @__PURE__ */ (() => {const data={};return ((_m, p)=>([{data,params:{"_":p.slice(1)}}]));})()
const decodeRoutePath = function decodeRoutePath(path) {
	if (!path.includes("%")) return path;
	const queryIndex = path.indexOf("?");
	const pathname = queryIndex === -1 ? path : path.slice(0, queryIndex);
	try {
		return queryIndex === -1 ? decodeURI(pathname) : decodeURI(pathname) + path.slice(queryIndex);
	} catch {
		return path;
	}
}
const normalizePath = (path, fold) => {
  if (typeof path !== 'string') { return path }
  const decoded = decodeRoutePath(path)
  return fold ? decoded.toLowerCase() : decoded
}
export default path => defu({}, ...foldedMatcher('', normalizePath(path, true)).map(r => r.data).reverse())